import { Box, styled } from '@mui/material';

const PREFIX = 'MetricCard';

export const classes = {
  cardContainer: `${PREFIX}-cardContainer`,
  subtitle: `${PREFIX}-subtitle`,
  title: `${PREFIX}-title`,
  value: `${PREFIX}-value`,
  valueContainer: `${PREFIX}-valueContainer`,
  changeValueContainer: `${PREFIX}-changeValueContainer`,
  arrowIcon: `${PREFIX}-arrowIcon`,
  changeText: `${PREFIX}-changeText`,
};

export const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.cardContainer}`]: {
    padding: theme.spacing(3, 2),
    background: '#F9FCFC',
    borderRadius: theme.shape.borderRadius,
    flexGrow: 0,
  },

  [`& .${classes.subtitle}`]: {
    fontWeight: 700,
    fontSize: '0.75rem',
    lineHeight: '0.75rem',
    color: theme.palette.text.secondary,
  },

  [`& .${classes.title}`]: {
    fontWeight: 700,
  },

  [`& .${classes.value}`]: {
    fontWeight: 700,
    fontSize: '1.5rem',
    color: theme.palette.common.black,
  },

  [`& .${classes.valueContainer}`]: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1),
  },

  [`& .${classes.changeValueContainer}`]: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(1),
  },

  [`& .${classes.arrowIcon}`]: {
    fontSize: '2rem',
    marginRight: '0.5rem',
    '&.up': {
      color: '#65C687',
    },
    '&.neutral': {
      color: theme.palette.text.secondary,
    },
    '&.down': {
      color: '#FF6B6B',
    },
  },

  [`& .${classes.changeText}`]: {
    fontWeight: 700,
    fontSize: '0.75rem',
    lineHeight: '0.75rem',
    '&.up': {
      color: '#65C687',
    },
    '&.down': {
      color: '#FF6B6B',
    },
    '&.neutral': {
      color: theme.palette.text.secondary,
    },
  },
}));
